export default __webpack_public_path__ + "static/media/tech-support.83b71938.svg";